import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './CaiwuPage.module.css'
import {
  ConfigProvider,
  Input,
  Menu,
  message,
  Modal,
  Tag,
  Tooltip,
  Upload,
} from 'antd'


import menu_points_recharge_order_list from './menu_points_recharge_order_list.svg'
import menu_points_recharge_order_list_selected from './menu_points_recharge_order_list_selected.svg'

import { selectCurrentMenuKey, setCurrentMenuKey } from './CaiwuPageSlice.js'
import {
  changeHeaderImgRequest,
  changeNameRequest,
  getAliOssTokenRequest,
} from './CaiwuPageApi.js'
import { getSixMathRandom } from '../../util/handMath.js'
import OSS from 'ali-oss'
import { ALI_OSS_PATH } from '../../util/constants.js'
import PointsRechargeOrderList from './PointsRechargeOrderList/PointsRechargeOrderList.js'
import Cookies from 'js-cookie'

let client
let clientExpTime

export default function CaiwuPage() {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const current = useSelector(selectCurrentMenuKey)
  const [arrow, setArrow] = useState('Show')
  const [openChangeNameModal, setOpenChangeNameModal] = useState(false)
  const [name, setName] = useState('')
  const [userHeaderImg, setUserHeaderImg] = useState(
    Cookies.get('image_url')
  )
  const mergedArrow = useMemo(() => {
    if (arrow === 'Hide') {
      return false
    }
    if (arrow === 'Show') {
      return true
    }
    return {
      pointAtCenter: true,
    }
  }, [arrow])

  const items = [
    {
      key: '1',
      icon: (
        <img
          src={
            String(current > 10 ? Math.floor(current / 10) : current) == 1
              ? menu_points_recharge_order_list_selected
              : menu_points_recharge_order_list
          }
          width={25}
          height={25}
        />
      ),
      label: '线上订单管理',
    },
  ]

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    getAliOssToken()

    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  const changeMenuMethod = (e) => {
    dispatch(setCurrentMenuKey(e.key))
  }

  const handleOk = (e) => {
    console.log(name)
    changeNameRequest(name, (data) => {
      console.log(data)
      if (data.ret == 1) {
        Cookies.set('name', name)
        setName('')
        setOpenChangeNameModal(false)
      } else {
        messageApi.info(data.msg)
      }
    })
  }

  const handleCancel = () => {
    setName('')
    setOpenChangeNameModal(false)
  }

  function getAliOssToken() {
    let nowDate = new Date().getTime()
    if (!client || nowDate - clientExpTime > 1200000) {
      clientExpTime = new Date().getTime()
      getAliOssTokenRequest((data) => {
        if ('Credentials' in data) {
          client = new OSS({
            // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
            region: 'oss-cn-qingdao',
            // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
            accessKeyId: data.Credentials.AccessKeyId,
            accessKeySecret: data.Credentials.AccessKeySecret,
            // 从STS服务获取的安全令牌（SecurityToken）。
            stsToken: data.Credentials.SecurityToken,
            refreshSTSToken: async () => {
              // 向您搭建的STS服务获取临时访问凭证。
              getAliOssTokenRequest((data) => {
                return {
                  accessKeyId: data.Credentials.AccessKeyId,
                  accessKeySecret: data.Credentials.AccessKeySecret,
                  stsToken: data.Credentials.SecurityToken,
                }
              })
            },
            // 刷新临时访问凭证的时间间隔，单位为毫秒。
            refreshSTSTokenInterval: 3000000,
            // 填写Bucket名称。
            bucket: 'tgnp',
          })
        }
      })
    }
  }

  const customRequest = async (options) => {
    const { onSuccess, onError, file } = options

    try {
      // 使用阿里云OSS SDK上传文件
      let timestamp = new Date().getTime()
      let random = getSixMathRandom()
      const result = await client.put(
        ALI_OSS_PATH + 'user/' + timestamp + random + file.name,
        file,
      )
      file.url = result.url.replace('http:', 'https:')
      onSuccess(file)
      changeImgMethod(file.url)
    } catch (e) {
      message.error(`头像上传失败`)
      onError(e)
    }
  }

  function changeImgMethod(url) {
    changeHeaderImgRequest(url, (data) => {
      console.log(data)
      if (data.ret == 1) {
        Cookies.set('image_url', url)
        setUserHeaderImg(url)
      } else {
        messageApi.info(data.msg)
      }
    })
  }

  function handleChange1(info) {
    getAliOssToken()
    let tempList = info.fileList.map((item, index) => {
      let tempDic = {
        url: item.url,
        uid: item.uid,
        status: item.status,
        name: item.name,
      }
      return tempDic
    })
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList)
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`)
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`)
    }
  }

  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      <div className={styles.leftMenus}>
        <img
          className={styles.menuLogo}
          src={require('../../assert/logo_name_icon.png')}
        ></img>
        <div className={styles.headerContainer}>
          <Upload
            listType="picture"
            fileList={[]}
            onChange={handleChange1}
            customRequest={customRequest}
            accept=".jpg,.png,.jpeg,.svg"
          >
            <img
              className={styles.avatar}
              src={
                userHeaderImg == 'null'
                  ? require('./avatar.png')
                  : userHeaderImg
              }
            ></img>
          </Upload>
          <div className={styles.rightBox}>
            <Tooltip
              placement="bottom"
              title={Cookies.get('name')}
              arrow={mergedArrow}
            >
              <text
                className={styles.teacherName}
                onClick={(e) => {
                  setOpenChangeNameModal(true)
                }}
              >
                {Cookies.get('name')}
              </text>
            </Tooltip>
          </div>
        </div>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#f5b544',
            },
          }}
        >
          <Menu
            defaultSelectedKeys={['1']}
            mode="inline"
            items={items}
            onClick={changeMenuMethod}
            selectedKeys={[
              String(current > 10 ? Math.floor(current / 10) : current),
            ]}
            inlineCollapsed={false}
          />
        </ConfigProvider>
        <Modal
          title="请输入新的名称"
          open={openChangeNameModal}
          onOk={handleOk}
          onCancel={handleCancel}
          width={300}
        >
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="请输入名称..."
          />
        </Modal>
      </div>
      <div className={styles.rightMenus}>
        <PointsRechargeOrderList />
      </div>
    </div>
  )
}
